cv.PublicFundraisersView = Marionette.LayoutView.extend({
  template: cv.Templates["public/fundraisers/fundraisers"],

  regions: {
    fundraisers_list: "#fundraisers-list",
  },

  events: {
    "click .fundraisers-toggle a": "toggle",
  },

  initialize: function (options) {
    this.options = options;

    console.log("PublicFundraisersView initialized");
  },

  templateHelpers: function () {
    return {
      heading: this.options.heading,
      subtitle: this.options.subheading,
      enable_teams: cv.campaign.get("enable_teams") == 1 ? true : false,
    };
  },

  toggle: function (e) {
    e.preventDefault();

    if (
      $(e.currentTarget).hasClass("toggle-fundraisers") &&
      !$(e.currentTarget).hasClass("active")
    ) {
      this.renderProjects();
    }
    if ($(e.currentTarget).hasClass("toggle-teams") && !$(e.currentTarget).hasClass("active")) {
      this.renderTeams();
    }
  },

  renderProjects: function () {
    this.showChildView(
      "fundraisers_list",
      new cv.PublicFundraisersCompositeView({
        collection: new cv.ProjectsNew(null, {
          params: {
            api_key: cv.PRELOADED.public_api_key,
            sort: "display_funds_raised",
            order: "desc",
            limit: 20,
          },
        }),
      })
    );

    this.$(".toggle-teams").removeClass("active");
    this.$(".toggle-fundraisers").addClass("active");
  },

  renderTeams: function () {
    this.showChildView(
      "fundraisers_list",
      new cv.PublicFundraisersCompositeView({
        collection: new cv.TeamsNew(null, {
          params: {
            api_key: cv.PRELOADED.public_api_key,
            sort: "display_funds_raised",
            order: "desc",
            limit: 20,
          },
        }),
      })
    );

    this.$(".toggle-fundraisers").removeClass("active");
    this.$(".toggle-teams").addClass("active");
  },

  onShow: function () {
    this.renderProjects();
  },
});
